enum SetCuttingHeightModalConstants {
  TOGGLE_MODAL_VISIBLE = '@SetCuttingHeightModalContainer/TOGGLE_MODAL_VISIBLE',
}

export default SetCuttingHeightModalConstants;
